module.exports = __webpack_public_path__ + "img/hzgs1.7a71997b.png";